import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../shared/components";
import { type AgeGenderMetrics } from "../../models";
import { ChartSkeletonContainer } from "../ChartSkeletonContainer";
import { StatsEmptyStateContainer } from "../shared";

import { AgeChart } from "./AgeChart";
import { GenderContainer, GenderLabel } from "./AgeChartComponent.styles";
import { LegendItem } from "./LegendItem";

export const AgeChartComponent: FC<{ metrics: AgeGenderMetrics; loading: boolean }> = ({ metrics, loading }) => (
    <StatsEmptyStateContainer isEmpty={!!metrics.isEmpty && !loading}>
        <Flexbox>
            <GenderContainer>
                <LegendItem
                    name="All Women"
                    color={Colors.Black.V50}
                    value={metrics.womenPct ?? ""}
                    loading={loading}
                />
            </GenderContainer>
            <GenderContainer>
                <LegendItem name="All Men" color={Colors.Gray.V250} value={metrics.menPct ?? ""} loading={loading} />
            </GenderContainer>
        </Flexbox>

        <GenderLabel>Age and Gender</GenderLabel>
        <ChartSkeletonContainer height={120} skeletonActive={loading}>
            <AgeChart stats={metrics.stats ?? []} />
        </ChartSkeletonContainer>
    </StatsEmptyStateContainer>
);
